import React, { useContext, useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { FormattedMessage } from "react-intl";
import { CusButton } from "../../Components/From/Button";
import { Global } from "../../App";
import _ from "lodash";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
// import {
//   cancelGetTermsAndPrivacy,
//   getTermsAndPrivacy
// } from "../../Api/GetPrivacyAndTerms";

function PrivacyPolicy(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [content, setContent] = useState("");
  const handlerErr = promise => {
    return promise
      .then(e => {
        return [null, e];
      })
      .catch(err => {
        return [err];
      });
  };
  // const apiTermsAndPrivacy = async () => {
  //   const langId = langStringToCode(globalState.langType);
  //   const [err, res] = await handlerErr(getTermsAndPrivacy(langId));
  //   if (err) {
  //     throw err;
  //   } else {
  //     const { errCode, result } = res.data;
  //     if (errCode == 200) {
  //       setContent(result.privacy);
  //     } else {
  //       setContent("Error.");
  //     }
  //   }
  // };
  // // 取得條款內容
  // useEffect(() => {
  //   apiTermsAndPrivacy();
  //   return () => {
  //     cancelGetTermsAndPrivacy("cancel");
  //   };
  // }, [globalState.langFile]);

  // if (!content) return null;

  const localPrivacy = () => {
    const langId = langStringToCode(globalState.langType);
    switch (langId) {
      case 1:
        return [
          {
            title: "隱私權保護聲明：",
            content: ["鼎泰豐小吃店股份有限公司除了提供消費者便利的購物環境外，我們也非常重視您的隱私權，因此訂定有關隱私權保護聲明。請您詳細閱讀下列有關隱私權保護內容。"]
          },
          {
            title: "個人資料的取得：",
            content: ["當使用者進入「鼎泰豐線上內用點餐」相關網站時，基本上並不需要輸入個人資料，例如姓名或電子郵件地址等。除非您要進行電子郵件信箱驗證，否則「鼎泰豐線上內用點餐」不會在使用者不知情的情況下，取得使用者之個人資料。「鼎泰豐線上內用點餐」相關網站會記錄使用者上站的登錄時間、以及在網站內的瀏覽活動等相關資料，但這些資料僅供作為流量分析和網路行為調查，以便於改善本網站的服務品質。在某些情況下，例如當使用者要求進行電子郵件信箱驗證、其他服務、或參加其他活動時，「鼎泰豐線上內用點餐」相關網站可能會要求使用者登錄資料，以便於聯繫、完成交易、提供訂餐及查詢服務、或處理訂餐流程；在此情況下，「鼎泰豐線上內用點餐」相關網站有明白告知使用者之義務，如果使用者選擇不接收任何訂單訊息或聯繫資訊，「鼎泰豐線上內用點餐」將完全予以尊重。"]
          },
          {
            title: "個人資料的利用：",
            content: ["「鼎泰豐線上內用點餐」及其相關網站所取得的個人資料，都僅供「鼎泰豐線上內用點餐」內部依照原說明的使用目的和範圍。除非事先說明或依照台灣相關法律規定，否則「鼎泰豐線上內用點餐」絕對不會將使用者的個人資料提供給第三者或作為其他目的之用。"]
          },
          {
            title: "資料安全：",
            content: ["為保障您個人的隱私及安全，您在「鼎泰豐線上內用點餐」內之帳號資料都以密碼保護。在部分情況下，「鼎泰豐線上內用點餐」採用SSL(Secure Socket Layer)128bit傳輸加密機制，以保障您資料傳送時的安全。"]
          },
          {
            title: "網路連結：",
            content: ["「鼎泰豐線上內用點餐」及其相關網站或網頁都可能包含其他網站或網頁的連結，對於這些不屬於「鼎泰豐線上內用點餐」之網站或網頁，不管其內容或隱私權政策，均與「鼎泰豐線上內用點餐」無關。"]
          }
        ];
      case 3:
        return [
          {
            title: "プライバシー保護宣言：",
            content: ["鼎泰豊小吃店股份有限公司は、消費者にとって便利な消費環境づくりのみならず、お客様のプライバシーをとても重視していることから、プライバシー保護宣言を定めています。プライバシー保護に係わる以下の内容をよく読んでください。"]
          },
          {
            title: "個人情報の取得：",
            content: ["ユーザーが「鼎泰豊オンライン店内飲食注文」に係わるサイトにアクセスするときは基本的に、氏名または電子メールアドレスといった個人情報を入力する必要はありません。お客様が電子メールボックス認証を行いたい場合を除き、「鼎泰豊オンライン店内飲食注文」は、ユーザーが事情を知らない状況下でユーザーの個人情報を取得することはありません。「鼎泰豊オンライン店内飲食注文」に係わるサイトは、ユーザーがサイトにアクセスして登録した時間、およびサイト内での閲覧行為等の情報を記録しますが、かかる情報は、本サイトのサービスの質を向上させるための行動フロー分析とネットにおける行為調査に用いられるのみです。たとえばユーザーが電子メールボックス認証を行いたい、その他のサービスを受けたい、またはその他の活動に参加したい等の状況下において、「鼎泰豊オンライン店内飲食注文」に係わるサイトは、ユーザーとの連係、取引の完了、予約注文および問合せサービスの提供、または予約注文処理手続きの便を図るため、ユーザーの登録データを求めることがあり、かかる状況下において、「鼎泰豊オンライン店内飲食注文」に係わるサイトは、ユーザーに対して明確に知らせる義務を有しており、ユーザーが本人の意思により注文書の情報またはお知らせの内容を受け入れない場合、「鼎泰豊オンライン店内飲食注文」は完全に尊重します。"]
          },
          {
            title: "個人情報の利用：",
            content: ["「鼎泰豊オンライン店内飲食注文」およびその関連サイトが取得した個人情報は、いずれも「鼎泰豊オンライン店内飲食注文」内部にのみ提供され、かつ表明済みの目的と範囲内で使用されます。事前に説明があった場合もしくは台湾の法律に従う場合を除き、「鼎泰豊オンライン店内飲食注文」はユーザーの個人情報を第三者に提供することも他の目的に使用することも絶対にありません。"]
          },
          {
            title: "情報セキュリティ：",
            content: ["お客様個人のプライバシーおよび安全を守るため、「鼎泰豊オンライン店内飲食注文」内におけるお客様のアカウント情報はパスワードで保護されています。一部の状況下においては、「鼎泰豊オンライン店内飲食注文」はSSL(Secure Socket Layer)128bit暗号化通信方式を用いて、お客様の情報送信時の安全を確保しています。"]
          },
          {
            title: "ネット上のリンク：",
            content: ["「鼎泰豊オンライン店内飲食注文」およびその関連サイトまたはサイトページは、いずれも他のサイトまたはサイトページを含むことがあり、かかる「鼎泰豊オンライン店内飲食注文」に属さないサイトまたはサイトページは、当該のコンテンツまたはプライバシーポリシーに係わらず、いずれも「鼎泰豊オンライン店内飲食注文」とは無関係です。"]
          }
        ];
      case 4:
        return [
          {
            title: "사생활 보호 성명:",
            content: ["딘타이펑 주식회사는 소비자에게 편리한 구매 환경을 제공하는 것 외에 귀하의 사생활 보호를 매우 중요시하고 있습니다. 이에 따라 사생활 보호와 관련한 성명을 하오니 사생활 보호에 관한 내용을 자세히 읽어 보시기 바랍니다."]
          },
          {
            title: "	개인 정보 취득:",
            content: [
              "이용자가 '딘타이펑 매장 내 온라인 메뉴 주문'에 관한 웹사이트에 들어왔을 경우, 기본적으로 성명, 전자 우편 주소 등 개인 정보를 입력할 필요는 없습니다. 전자 우편함을 인증해야 하는 경우가 아니라면 '딘타이펑 매장 내 온라인 메뉴 주문' 시 이용자 모르게 이용자의 개인 정보를 취득하지 않습니다. '딘타이펑 매장 내 온라인 메뉴 주문' 관련 웹사이트는 이용자의 로그인 시간과 웹사이트 내에서 살핀 내역 등 관련 정보를 기록하지만 이러한 정보는 데이터 분석 및 네트워크 시장 조사, 웹사이트 서비스 품질 개선에 사용됩니다.",
              "'딘타이펑 매장 내 온라인 주문' 관련 웹사이트는 이용자의 전자 우편함 인증, 기타 서비스, 기타 이벤트 참여 등과 같은 특정 상황에서 이용자에게 로그인 정보를 요구하여 연결, 주문, 예약 및 서비스 조회, 주문 처리 상황 등을 편리하게 이용할 수 있도록 합니다. 이때 '딘타이펑 매장 내 온라인 주문'관련 웹사이트는 이용자에게 명확히 고지할 의무가 있으나 이용자가 어떠한 예약 정보 또는 연락 정보를 수신하지 않길 원한다면 '딘타이펑 매장 내 온라인 주문'은 이를 존중합니다."
            ]
          },
          {
            title: "개인 정보 이용:",
            content: ["'딘타이펑 매장 내 온라인 주문' 및 관련 웹사이트에서 취득한 개인 정보는 기존에 설명했던 사용 목적과 범위에 따라 '딘타이펑 매장 내 온라인 주문' 내부에만 제공됩니다. 사전에 설명했거나 타이완의 관련 법률 규정에 의거하지 않는 한 '딘타이펑 매장 내 온라인 주문'은 절대 이용자의 개인 정보를 제삼자에게 제공하거나 기타 목적으로 이용하지 않습니다."]
          },
          {
            title: "정보 안전:",
            content: ["귀하의 사생활 및 안전 보장을 위해 귀하의 '딘타이펑 매장 내 온라인 주문' 계정 정보는 비밀번호로 보호합니다. 일부는 '딘타이펑 매장 내 온라인 주문'에서 채용한 SSL(Secure Socket Layer)128bit 보안 강화 메커니즘으로 귀하의 정보를 안전하게 전송할 것을 보장합니다."]
          },
          {
            title: "네트워크 연결:",
            content: ["'딘타이펑 매장 내 온라인 주문' 및 관련 웹사이트 또는 홈페이지는 기타 웹사이트 또는 홈페이지 링크를 포함할 수 있으나 '딘타이펑 매장 내 온라인 주문'에 속하지 않는 웹사이트 또는 홈페이지의 내용 또는 사생활 정책은 '딘타이펑 매장 내 온라인 주문'과 무관합니다."]
          }
        ];
      case 2:
      default:
        return [
          {
            title: "Privacy Protection Statement",
            content: ["Din Tai Fung Restaurant Co., Ltd not only provides customers with a convenient environment for shopping, but also takes your privacy seriously. Please read the following contents of privacy protection in detail."]
          },
          {
            title: "Access to Personal Information",
            content: ["When users enter to the relevant website of “Din Tai Fung Online Dine-In Order”, basically they don’t need to enter personal information, for example, name or email address. Unless you proceed to verify email, “Din Tai Fung Online Dine-In Order” will not access to the personal information from users in user’s unknown situations. The relevant website of “Din Tai Fung Online Dine-In Order” will document user’s login time and the relevant data reviewing pages on the website. However, in order to improve the service quality of this website, these data are only for flow analysis and internet behavior conduction. In certain circumstances: users request to access email verification, other services or attend other activities, the relevant website of “Din Tai Fung Online Dine-In Order” may request users to leave login information for convenient to contact, complete transaction, supply the service for order and inquisition, or deal with procedure for meal reservation. In these circumstances, the relevant website of “Din Tai Fung Online Dine-In Order” does have the obligation to inform user. If user refuses to accept any order message or contact information, “Din Tai Fung Online Dine-In Order” will take respect on it."]
          },
          {
            title: "Advantage of Personal Information",
            content: ["The personal information from “Din Tai Fung Online Dine-In Order” and its relevant website are only for their original usage purpose and range. Unless inform in advance or regulate by the relevant regulations in Taiwan, “Din Tai Fung Online Dine-In Order” will never offer user’s personal information to the third party or use it for another purpose."]
          },
          {
            title: "Data Security",
            content: ["To protect your personal privacy and security, your account information in “Din Tai Fung Online Dine-In Order” will be encoded. In certain circumstances, “Din Tai Fung Online Dine-In Order” adopts SSL (Secure Socket Layer) 128bit to transfer encoded mechanism to ensure the security process of transmitting your data."]
          },
          {
            title: "Internet Connection",
            content: ["“Din Tai Fung Online Dine-in Order” and other website (or web page) may contain the link of other website or web page. Those website or web pages don’t belong to “Din Tai Fung Online Dine-in Order” .No matter its contents or privacy policy, they are nothing to do with “Din Tai Fung Online Dine-in Order”."]
          }
        ];
    }
  }

  return (
    <div className="Pages">
      <Header />
      <div className="TakeOrder col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
        <div className="Pages__terms col d-flex flex-column align-items-center p-0">
          <div className="Pages__section d-flex justify-content-center pb-3 pb-sm-4">
            <div className="Pages__title d-flex">
              <FormattedMessage
                id="pages.privacyPolicy.title"
                children={e => {
                  const { langType } = globalState;
                  if (
                    langType !== "zh" &&
                    langType !== "ja" &&
                    langType !== "ko"
                  ) {
                    const splitString = e.split(" ");
                    return splitString.map((e, index) => (
                      <div
                        key={index}
                        className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                      >
                        <div>{e}</div>
                      </div>
                    ));
                  } else {
                    const splitString = e.split("");
                    return splitString.map((e, index) => (
                      <div
                        key={index}
                        className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                      >
                        <div>{e}</div>
                      </div>
                    ));
                  }
                }}
              />
            </div>
          </div>
          {/* Content */}
          <div className="Pages__section Pages__justify">
            {
              localPrivacy().map((e, index) => (
                <div className="Pages__terms__paragraph mb-4" key={index}>
                  <div className="Pages__terms__title mb-2">{e.title}</div>
                  <div className="Pages__terms__content">{
                    e.content.map((subItem, subIndex) => (
                      <div key={subIndex}>{subItem}</div>
                    ))
                  }</div>
                </div>
              ))
            }
            {/* <div dangerouslySetInnerHTML={{ __html: content }}></div> */}
          </div>
          <div className="Pages__section d-flex">
            <div className="Pages__section d-flex justify-content-center mt-4 mb-4">
              <CusButton.White
                className="p-3 pr-5 pl-5 col col-sm-auto"
                children={
                  <FormattedMessage id="pages.privacyPolicy.buttonBack" />
                }
                onClick={() => {
                  window.close();
                  setTimeout(() => {
                    props.history.goBack();
                  }, 200);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
